<div class="landing">
  <header>
    <div class="header wrapp" [ngClass]="isBottom ? 'headerbgclr' : ''">
      <div class="header-icons mr-l">
        <span style="margin: 0px 4px 0px 10px; display: none">
          <i
            class="fa fa-bars"
            aria-hidden="true"
            style="font-size: 30px; color: white"
          ></i>
        </span>
        <span>
          <a href="/">
            <img
              src="https://cdn.catexpert.ab-inbev.com/assets/images/{{
                this.domainType === 'pho' ? 'logo-pho.svg' : 'header-logo.png'
              }}"
              class="header-logo"
              [ngClass]="domainType === 'pho' ? 'logo-pho' : ''"
          /></a>
        </span>
      </div>
      <div class="header-icons mr-r">
        <button class="nav-item" (click)="scrollToElement(home)">
          {{ "LANDING.NAV.HOME" | translate }}
        </button>
        <button class="nav-item" (click)="scrollToElement(features)">
          {{ "LANDING.NAV.FEATURES" | translate }}
        </button>
        <button class="nav-item" (click)="scrollToElement(about)">
          {{ "LANDING.NAV.ABOUT_US" | translate }}
        </button>
        <button class="nav-item" (click)="scrollToElement(faqs)">
          {{ "LANDING.NAV.FAQS" | translate }}
        </button>
        <button class="nav-item" (click)="scrollToElement(contact)">
          {{ "LANDING.NAV.CONTACT_US" | translate }}
        </button>
        <div class="landing-language-toggle language-dropdown">
          <span class="landing-language-label">
            {{ "LANDING.NAV.LANGUAGE" | translate }}
          </span>
          <span class="pipe-border"></span>
          <img style="width: 18px" src="https://cdn.catexpert.ab-inbev.com/assets/images/globe.svg" />

          <button
            mat-button
            #landingLanguageTrigger="matMenuTrigger"
            [matMenuTriggerFor]="landingLanguageMenu"
            class="language-btn"
            [class.active]="landingLanguageTrigger.menuOpen"
          >
            <span>{{ selectedLanguage }}</span>
            <span class="material-icons material-icons-outlined arrow-icon"
              >expand_more</span
            >
          </button>

          <mat-menu
            #landingLanguageMenu="matMenu"
            yPosition="above"
            class="user-dropdown"
          >
            <button
              (click)="onLanguageChange(item.language)"
              mat-menu-item
              *ngFor="let item of languageList"
            >
              {{ item.languageName | translate }}
            </button>
          </mat-menu>
          <span class="pipe-border ml-1"></span>
        </div>
        <button class="go-to-studio" (click)="continueToLogin()">
          {{ "LANDING.NAV.LOGIN_TO_STUDIO" | translate }}
        </button>
      </div>
    </div>
  </header>

  <section #home id="home">
    <div class="landing-banner">
      <div id="bg" class="bg" style="position: relative">
        <div class="banner-layer-2">
          <div class="overlay"></div>
        </div>
        <div style="width: 100%; float: left">
          <div class="inner_content_home">
            <div class="hg-wrapper">
              <div class="hg hg-1" [ngClass]="{ active: animationIndex === 0 }">
                <div class="h-line">
                  <p>{{ "LANDING.HERO.SLIDE_1_LINE_1" | translate }}</p>
                </div>
                <div class="h-line">
                  <p>{{ "LANDING.HERO.SLIDE_1_LINE_2" | translate }}</p>
                </div>
                <div class="sub-h-line css-typing" #typewriterContainerDiv>
                  <p>{{ "LANDING.HERO.SLIDE_1_SUB" | translate }}</p>
                </div>
              </div>
              <div class="hg hg-2" [ngClass]="{ active: animationIndex === 1 }">
                <div class="h-line">
                  <p>{{ "LANDING.HERO.SLIDE_2_LINE_1" | translate }}</p>
                </div>
                <div class="h-line">
                  <p>{{ "LANDING.HERO.SLIDE_2_LINE_2" | translate }}</p>
                </div>
                <div class="sub-h-line css-typing">
                  <p>{{ "LANDING.HERO.SLIDE_2_SUB" | translate }}</p>
                </div>
              </div>
              <div class="hg hg-3" [ngClass]="{ active: animationIndex === 2 }">
                <div class="h-line">
                  <p>{{ "LANDING.HERO.SLIDE_3_LINE_1" | translate }}</p>
                </div>
                <div class="h-line">
                  <p>{{ "LANDING.HERO.SLIDE_3_LINE_2" | translate }}</p>
                </div>
                <div class="sub-h-line css-typing">
                  <p>{{ "LANDING.HERO.SLIDE_3_SUB" | translate }}</p>
                </div>
              </div>
              <div class="hg hg-4" [ngClass]="{ active: animationIndex === 3 }">
                <div class="h-line">
                  <p>{{ "LANDING.HERO.SLIDE_4_LINE_1" | translate }}</p>
                </div>
                <div class="h-line">
                  <p>{{ "LANDING.HERO.SLIDE_4_LINE_2" | translate }}</p>
                </div>
                <div class="sub-h-line css-typing">
                  <p>{{ "LANDING.HERO.SLIDE_4_SUB_LINE_1" | translate }}</p>
                  <p>{{ "LANDING.HERO.SLIDE_4_SUB_LINE_2" | translate }}</p>
                </div>
              </div>
            </div>
            <button class="know_more" (click)="scrollToElement(features)">
              {{ "LANDING.HERO.LEARN_MORE" | translate }}
            </button>
          </div>
        </div>
        <div class="bottom_content_home">
          <div
            class="section_three"
            *ngFor="let content of bannerContent; let i = index"
          >
            <div class="icon" [style.background]="content.color">
              <img src="{{ content.image }}" />
            </div>
            <div class="banner_label">{{ content.label | translate }}</div>
            <div
              class="banner_desc"
              [innerHTML]="content.description | translate"
            ></div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section #features id="features">
    <div class="feature-section section">
      <div class="section_title text-v-border">
        <h5>{{ "LANDING.SECTION.PRODUCT" | translate }}</h5>
        <h3>
          <span>{{ "LANDING.SECTION.FEATURES_FOR_YOU" | translate }}</span>
        </h3>
      </div>

      <div id="all-features" class="all-features">
        <div
          *ngFor="let feature of allFeature; let i = index"
          class="feature-wrapp"
        >
          <div class="feature" style="width: 100%">
            <img src="{{ feature.bg_image }}" />
            <div class="description">
              <label
                ><strong>{{ feature.label | translate }}</strong>
              </label>
              <p class="short_desc{{ feature.id }}">
                {{ feature.short_description | translate }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section #about class="about" id="about">
    <div class="about_content" *ngIf="domainType !== 'pho'">
      <div class="lft_content">
        <h5>{{ "LANDING.SECTION.ABOUT_US" | translate }}</h5>
        <h3><span>{{ "LANDING.SECTION.OUR_COMPETENCIES" | translate }}</span></h3>
        <div class="about_desc">
          <ul>
            <li>
              {{ "LANDING.ABOUT.BULLET_1" | translate }}
            </li>
            <li>
              {{ "LANDING.ABOUT.BULLET_2" | translate }}
            </li>
            <li>
              {{ "LANDING.ABOUT.BULLET_3" | translate }}
            </li>
            <li>
              {{ "LANDING.ABOUT.BULLET_4" | translate }}
            </li>
            <li>
              {{ "LANDING.ABOUT.BULLET_5" | translate }}
            </li>
            <li>{{ "LANDING.ABOUT.BULLET_6" | translate }}</li>
            <li>
              {{ "LANDING.ABOUT.BULLET_7" | translate }}
            </li>
            <li>
              {{ "LANDING.ABOUT.BULLET_8" | translate }}
            </li>

            <strong class="text-pop"></strong>
          </ul>
        </div>
      </div>
      <div class="rht_content">
        <div style="position: relative" class="wrapper">
          <div class="overlay"></div>
          <div class="circle_content circle_contentB">
            <div class="icon">
              <img src="https://cdn.catexpert.ab-inbev.com/assets/images/key_acc.svg" />
            </div>
            <div class="content">
              <span>{{ "LANDING.ABOUT.STAT_1_TITLE" | translate }}</span>
              <span>{{ "LANDING.ABOUT.STAT_1_SUBTITLE" | translate }}</span>
            </div>
          </div>

          <div class="circle_content circle_contentV">
            <div class="icon">
              <img src="https://cdn.catexpert.ab-inbev.com/assets/images/country.svg" />
            </div>
            <div class="content">
              <span>{{ "LANDING.ABOUT.STAT_2_TITLE" | translate }}</span>
              <span>{{ "LANDING.ABOUT.STAT_2_SUBTITLE" | translate }}</span>
            </div>
          </div>

          <div class="circle_content circle_contentS">
            <div class="icon">
              <img src="https://cdn.catexpert.ab-inbev.com/assets/images/data.svg" />
            </div>
            <div class="content">
              <span>{{ "LANDING.ABOUT.STAT_3_TITLE" | translate }}</span>
              <span>{{ "LANDING.ABOUT.STAT_3_SUBTITLE" | translate }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section #faqs id="faqs">
    <div class="faq-section section">
      <div class="all-faqs text-v-border">
        <h5>{{ "LANDING.SECTION.FAQS" | translate }}</h5>
        <h3>
          <span>{{ "LANDING.SECTION.FREQUENTLY_ASKED_QUESTIONS" | translate }}</span>
        </h3>
        <div class="accordion-item">
          <h2 class="accordion-header" id="heading-0">
            <button
              type="button"
              class="accordion-button collapsed"
              data-bs-toggle="collapse"
              data-bs-target="#collapse-0"
            >
              {{ "LANDING.FAQ.ACCESS_QUESTION" | translate }}
            </button>
          </h2>
          <div
            id="collapse-0"
            class="accordion-collapse collapse"
            data-bs-parent="#myAccordion"
          >
            <div class="card-body">
              <p>
                {{ "LANDING.FAQ.ACCESS_ANSWER_PREFIX" | translate }}
                <a
                  (click)="scrollToElement(contact)"
                  style="color: #e5b629; font-weight: bold; cursor: pointer"
                  >{{ "LANDING.FAQ.ACCESS_ANSWER_LINK" | translate }}</a
                >
                {{ "LANDING.FAQ.ACCESS_ANSWER_SUFFIX" | translate }}
                {{ "LANDING.FAQ.ACCESS_ANSWER_FOLLOWUP" | translate }}
              </p>
            </div>
          </div>
        </div>
        <div class="accordion" id="myAccordion">
          <div
            *ngFor="let faq of allFaq; let i = index"
            class="accordion-item"
            id="{{ i === 2 ? 'onboarding' : '' }}"
          >
            <h2 class="accordion-header" id="heading-{{ i + 1 }}">
              <button
                type="button"
                class="accordion-button collapsed"
                data-bs-toggle="collapse"
                attr.data-bs-target="#collapse-{{ i + 1 }}"
              >
                {{ faq.question | translate }}
              </button>
            </h2>
            <div
              id="collapse-{{ i + 1 }}"
              class="accordion-collapse collapse"
              data-bs-parent="#myAccordion"
            >
              <div class="card-body">
                <p [innerHTML]="faq.answer | translate"></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div #contact id="contact" class="get_in_touch">
      <h3 *ngIf="!isSuccessMessage">
        {{ "LANDING.CONTACT.READY_TO_GET_STARTED" | translate }}
      </h3>
      <p *ngIf="!isSuccessMessage">
        {{ "LANDING.CONTACT.DOES_NOT_HAVE_ACCESS" | translate }}
      </p>
      <form
        class="get_in_touch_form"
        *ngIf="!isSuccessMessage"
        [formGroup]="custom"
      >
        <div class="form_fields form-group">
          <input
            type="text"
            formControlName="email"
            class="input-get"
            [placeholder]="'LANDING.CONTACT.EMAIL_PLACEHOLDER' | translate"
          />
          <app-form-error
            type="landing"
            formControlName="email"
            [errors]="errors.email"
          >
          </app-form-error>
        </div>

        <div class="form_fields">
          <select class="select-get" formControlName="zone">
            <option value="">{{ "LANDING.CONTACT.ZONE_OPTION" | translate }}</option>
            <option *ngFor="let list of zonelist" value="{{ list.id }}">
              {{ list.name }}
            </option>
          </select>
          <app-form-error
            type="landing"
            formControlName="zone"
            [errors]="errors.zone"
          >
          </app-form-error>
        </div>

        <div class="form_fields">
          <button class="get_in_touch_btn" (click)="Getstarted()">
            {{ "LANDING.CONTACT.GET_STARTED" | translate }}
          </button>
        </div>
      </form>
      <div class="get_in_touch_error" *ngIf="isSuccessMessage">
        {{ successMessage | translate }}
      </div>
    </div>
  </section>

  <footer>
    <div class="landing-footer">
      <div class="newsletter_section">
        <span *ngIf="domainType !== 'pho'">
          <a href="/">
            <img
              src="https://cdn.catexpert.ab-inbev.com/assets/images/catexpert-footer-logo.png"
              class="footer-logo"
              [attr.alt]="'LANDING.FOOTER.FOOTER_LOGO_ALT' | translate" /></a
          ><br />
        </span>

        <span
          class="footer-logo"
          [ngClass]="domainType === 'pho' ? 'logo-pho' : ''"
          *ngIf="domainType === 'pho'"
        >
        </span>

        <span>
          <a
            href="https://abinbev-india.com/teams/gcc-india"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i>
              <img
                src="https://cdn.catexpert.ab-inbev.com/assets/images/gac-footer-logo.png"
                class="img-space img-dim"
              />
            </i>
          </a>

          <a
            href="https://abinbev-india.com/teams/gcc-india"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i>
              <img
                src="https://cdn.catexpert.ab-inbev.com/assets/images/gcc-footer-logo.png"
                class="img-space img-dim"
              />
            </i>
          </a>

          <a
            href="https://abinbev-india.com/teams/gcc-india"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i>
              <img
                src="https://cdn.catexpert.ab-inbev.com/assets/images/brewdat-footer-logo.png"
                class="img-space brewdat"
              />
            </i>
          </a>

          <a
            href="https://www.ab-inbev.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i>
              <img
                src="https://cdn.catexpert.ab-inbev.com/assets/images/abinbev-footer-logo.png"
                class="abinbev"
              />
            </i>
          </a>
        </span>
      </div>
      <div class="copy-rights-border"></div>
      <div class="copy-rights-section">
        <div>
          <span class="social-medias">
            <a
              href="https://www.facebook.com/abinbev"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i>
                <img
                  src="https://cdn.catexpert.ab-inbev.com/assets/images/facebook-social-logo.png"
                  class="img-space social-images"
              /></i>
            </a>

            <a
              href="https://www.instagram.com/abinbev"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i
                ><img
                  src="https://cdn.catexpert.ab-inbev.com/assets/images/instagram-social-logo.png"
                  class="img-space social-images"
              /></i>
            </a>

            <a
              href="https://twitter.com/abinbev"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i>
                <img
                  src="https://cdn.catexpert.ab-inbev.com/assets/images/twitter-social-logo.png"
                  class="img-space social-images"
              /></i>
            </a>

            <a
              href="https://www.linkedin.com/company/ab-inbev"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i>
                <img
                  src="https://cdn.catexpert.ab-inbev.com/assets/images/linkedin-social-logo.png"
                  class="img-space social-images"
                />
              </i>
            </a>
          </span>
        </div>

        <div class="copy-right">
          <span
            >© 2022
            <a
              href="https://www.ab-inbev.com/"
              target="_blank"
              rel="noopener noreferrer"
              >Anheuser-Busch InBev</a
            >
            {{ "LANDING.FOOTER.COPYRIGHT" | translate }}
          </span>
        </div>
      </div>
    </div>
  </footer>
</div>
